// src/FlowContextWrapper.tsx
import React2, { useCallback, useEffect, useState } from "react";

// src/provider/flowContextProvider.tsx
import React, { createContext, useContext } from "react";
var AwaitedFlowStateContext = createContext({});
var createFlowContext = () => {
  return createContext(null);
};
var useFlowState = () => {
  const context = useContext(AwaitedFlowStateContext);
  if (!context) {
    throw Error("Empty context is not allowed!");
  }
  return context;
};
var FlowContextProvider = ({
  state,
  children
}) => {
  const awaitedFlowState = useContext(AwaitedFlowStateContext) ?? {};
  const value = { ...awaitedFlowState, ...state };
  return awaitedFlowState && /* @__PURE__ */ React.createElement(AwaitedFlowStateContext.Provider, {
    value
  }, children);
};

// src/FlowContextWrapper.tsx
import { isEqual } from "lodash";
var FlowContextWrapper = (props) => {
  const { state, loader, onError, children } = props;
  const [loading, setLoading] = useState(true);
  const [awaitedState, setAwaitedState] = useState();
  const awaitState = useCallback(async (promiseState) => {
    const promises = Object.values(promiseState);
    const keys = Object.keys(promiseState);
    try {
      const values = await Promise.all(promises);
      const newState = values.reduce((acc, result, index) => {
        const key = keys[index];
        acc[key] = result;
        return acc;
      }, {});
      const emptyProps = Object.entries(newState).filter(([, value]) => value === void 0 || value === null);
      if (!emptyProps.length) {
        setAwaitedState((prevState) => {
          if (isEqual(prevState, newState)) {
            return prevState;
          }
          return newState;
        });
        setLoading(false);
      }
    } catch (error) {
      onError?.(error);
      setLoading(false);
    }
  }, [onError]);
  useEffect(() => {
    if (state) {
      awaitState(state);
    }
  }, [awaitState, state]);
  if (loading || !awaitedState) {
    return loader === void 0 ? /* @__PURE__ */ React2.createElement("div", null, "Loading...") : loader;
  }
  return /* @__PURE__ */ React2.createElement(FlowContextProvider, {
    state: awaitedState
  }, children);
};
export {
  FlowContextProvider,
  FlowContextWrapper,
  createFlowContext,
  useFlowState
};
//# sourceMappingURL=index.js.map
